<template>
  <div class="dev-wrapper">
    <div class="dev-card">
      <!-- Device ID Editable & Copyable -->
      <div class="section">
        <label class="section-label">أدخل رقمك التسلسلي</label>
        <div class="input-block">
          <textarea
            v-model="deviceId"
            placeholder="أدخل حسابك هنا "
            class="device-input"
            rows="3"
          />
        </div>
        <div class="button-block">
          <button
            class="paste-btn"
            @click="pasteDeviceId"
            :title="'لصق الرقم التسلسلي'"
          >
            <i class="fas fa-paste"></i>
          </button>
          <button
            class="copy-btn"
            :class="{ success: copySuccess }"
            @click="copyDeviceId"
            :title="copySuccess ? 'تم النسخ!' : 'نسخ المعرّف'"
          >
            <i :class="copySuccess ? 'fas fa-check' : 'fas fa-copy'"></i>
          </button>
        </div>
        <p class="hint">✏️ يمكنك إدخال أي رقم أو نص ثم نسخه بالضغط على الأيقونة.</p>
      </div>

      <!-- Generate Activation Code -->
      <div class="section center">
        <button
          class="gen-btn"
          @click="generateCode"
          :disabled="isGenerating || !deviceId"
        >
          <i class="fas fa-key btn-icon"></i>
          <span v-if="!isGenerating">توليد الكود</span>
          <span v-else>جارٍ التوليد...</span>
        </button>
      </div>

      <!-- Activation Code Display -->
      <div v-if="activationCode" class="section">
        <label class="section-label">كلمة مرور حسابك</label>
        <div class="copy-block">
          <code class="activation-code">{{ activationCode }}</code>
          <button
            class="copy-btn"
            :class="{ success: activationCopySuccess }"
            @click="copyActivationCode"
            :title="activationCopySuccess ? 'تم النسخ!' : 'نسخ الكود'"
          >
            <i :class="activationCopySuccess ? 'fas fa-check' : 'fas fa-copy'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Subtle Sparkle Overlay -->
    <div class="sparkles">
      <span
        v-for="n in 12"
        :key="n"
        class="sparkle"
        :style="{
          '--x': Math.random() * 100 + 'vw',
          '--y': Math.random() * 100 + 'vh',
          '--size': (4 + Math.random() * 4) + 'px',
          '--delay': Math.random() * 5 + 's'
        }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeveloperPage',
  data() {
    return {
      deviceId: '',
      activationCode: '',
      isGenerating: false,
      copySuccess: false,
      activationCopySuccess: false
    }
  },
  methods: {
    copyDeviceId() {
      if (!this.deviceId) return
      navigator.clipboard.writeText(this.deviceId)
      this.copySuccess = true
      setTimeout(() => (this.copySuccess = false), 1500)
    },
    pasteDeviceId() {
      navigator.clipboard.readText().then(text => {
        this.deviceId = text
      })
    },
    async generateCode() {
      if (!this.deviceId) return
      this.isGenerating = true
      await new Promise(r => setTimeout(r, 800))
      this.activationCode = btoa(this.deviceId).slice(0, 10)
      this.isGenerating = false
    },
    copyActivationCode() {
      navigator.clipboard.writeText(this.activationCode)
      this.activationCopySuccess = true
      setTimeout(() => (this.activationCopySuccess = false), 1500)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css');

/* خلفية فاخرة */
.dev-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #1877F2, #0F5BB5);
  font-family: 'Cairo', sans-serif;
  padding: 1rem;
}

/* البطاقة */
.dev-card {
  background: #fff;
  border-radius: 20px;
  padding: 2rem;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.8s ease;
  border: 1px solid #e4e6eb;
}

/* الهيدر */
.dev-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.section-label {
  font-weight: 700;
  color: #1C1E21;
  margin-bottom: 0.6rem;
  font-size: 1rem;
}

/* حقل الإدخال */
.input-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.device-input {
  width: 100%;
  background: #F0F2F5;
  border: 1px solid #d0d0d0;
  border-radius: 12px;
  padding: 0.6rem;
  color: #1C1E21;
  font-size: 0.9rem;
  resize: none; /* Prevent resizing */
}

/* زر النسخ و اللصق */
.button-block {
  display: flex;
  justify-content: space-between;
}
.copy-btn, .paste-btn {
  background: #1877F2;
  border: none;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.6rem 1rem;
  border-radius: 999px; /* pill style */
  transition: 0.3s;
}

.copy-btn:hover, .paste-btn:hover {
  background: #0F5BB5;
}

.hint {
  margin-top: 0.4rem;
  font-size: 0.8rem;
  color: #555;
}

/* زر التوليد */
.gen-btn {
  width: 100%;
  background: #1877F2;
  color: #fff;
  border: none;
  border-radius: 999px; /* pill style */
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  margin-top: 1rem;
}

.gen-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* كود التفعيل */
.copy-block {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: 0.8rem;
}
.activation-code {
  background: #F0F2F5;
  color: #1C1E21;
  font-family: monospace;
  padding: 1rem;
  border-radius: 12px;
  font-size: 1rem;
  word-break: break-all;
  border: 1px solid #d0d0d0;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* أنيميشن */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>